import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import DropdownMenu from 'components/DropdownMenu';

import './MainNav.scss';

class MenuLink extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        dropdown: PropTypes.bool.isRequired,
        columns: PropTypes.array,
        isActive: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.bool,
        ]),
        mobile: PropTypes.bool.isRequired,
        onClick: PropTypes.func.isRequired,
        id: PropTypes.number.isRequired,
        link: PropTypes.string,
        linkText: PropTypes.string,
        wasActive: PropTypes.bool,
        closeMenuLabel: PropTypes.string.isRequired,
    }

    _handleOnClick = e => {
        e.preventDefault();
        this.props.onClick(this.props.id);
    }

    render() {
        const {
            linkText,
            link,
            columns,
            dropdown,
            isActive,
            wasActive,
            mobile,
            closeMenuLabel,
        } = this.props;

        if(! linkText) return null;

        const topMenuLink = link ? { linkText, link } : null;

        return(
            <li>
                <a
                    className={classnames({
                        'dropdown': dropdown,
                        'active': isActive,
                    })}
                    href={link || "#"}
                    onClick={columns.length > 0 ? this._handleOnClick : null}
                >{linkText}</a>
                {dropdown && (
                    <DropdownMenu
                        columns={columns}
                        isActive={isActive}
                        wasActive={wasActive}
                        mobile={mobile}
                        topMenuLink={topMenuLink}
                        closeMenu={this._handleOnClick}
                        closeMenuLabel={closeMenuLabel}
                    />
                )}
            </li>
        );
    }
}

class MainNav extends React.PureComponent {
    static propTypes = {
        menu: PropTypes.arrayOf(PropTypes.shape({
            columns: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
                link: PropTypes.string,
                linkText: PropTypes.string,
                menuItems: PropTypes.arrayOf(PropTypes.shape({
                    href: PropTypes.string,
                    language: PropTypes.string,
                    target: PropTypes.string,
                    text: PropTypes.string,
                    title: PropTypes.string
                }))
            })))
        })).isRequired,
        onClick: PropTypes.func.isRequired,
        isActiveOnMobile: PropTypes.bool.isRequired,
        isActive: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.bool,
        ]),
        closeMenuLabel: PropTypes.string.isRequired,
    }

    render() {
        const {
            menu,
            onClick,
            isActiveOnMobile,
            isActive,
            closeMenuLabel,
        } = this.props;

        const classNames = classnames('menu', {
            'open': isActiveOnMobile,
        });

        return(
            <nav className={classNames} role="navigation">
                <ul className="top-header-menu">
                    {menu.map((l, i) => (
                        <MenuLink
                            key={i}
                            id={i}
                            dropdown={l.columns.length > 0}
                            onClick={onClick}
                            isActive={isActive === i ? true : false}
                            mobile={isActiveOnMobile}
                            closeMenuLabel={closeMenuLabel}
                            {...l}
                        />
                    ))}
                </ul>
            </nav>
        );
    }
}

export default MainNav;



// WEBPACK FOOTER //
// ./src/components/MainNav/MainNav.jsx